<app-new-revision-notice-details-section *ngIf="iagPortalRevisionNoticesPage.detailsXMLSections" [sections]="iagPortalRevisionNoticesPage.detailsXMLSections"> </app-new-revision-notice-details-section>
